// Cart related
export const CART_UUID_STORAGE_KEY: string = 'cart.uuid.' + import.meta.env.VITE_APP_ENV_NAME

/** Same-family subscription already on account (blocks checkout) */
export const CART_ERROR_CODE_EXISTING_SUBSCRIPTION = 4924

/** Pitch 'n Time upgrade not available for this account */
export const CART_ERROR_CODE_INELIGIBLE_PNT_UPGRADE = 4925

/**
 * Blocks checkout when the account already has an active Serato subscription and an
 * active or expiring Apple subscription in the same family (would be a third license).
 * Ecom error: 4939 (InvalidPurchaseSameFamilyWithActiveAppleSubscriptionException).
 */
export const APPLE_MULTISUB_BLOCK_ERROR_CODE_ACTIVE = 4939

/**
 * Blocks checkout when the account already has an active Serato subscription and an
 * Apple subscription in the same family that is past due or in canceled-retry
 * (Apple may attempt to restart billing). Ecom error: 4940
 * (InvalidPurchaseSameFamilyWithDunningAppleSubscriptionException — "dunning" in Ecom
 * refers to these subscription statuses, not customer-facing copy).
 */
export const APPLE_MULTISUB_BLOCK_ERROR_CODE_PAST_DUE_OR_CANCELLED_RETRY = 4940

/**
 * Soft warning when the account has an active or expiring Apple-managed subscription in
 * the same product family. Checkout may continue. Ecom warning: 100001.
 */
export const APPLE_SUBSCRIPTION_WARNING_CODE_ACTIVE = 100001

/**
 * Soft warning when the account has an Apple-managed subscription in the same product
 * family that is past due or in canceled-retry (Apple may attempt to restart billing).
 * Checkout may continue. Ecom warning: 100002
 * (APPLE_WARNING_CODE_DUNNING_SUBSCRIPTION in Ecom — "dunning" is internal billing jargon).
 */
export const APPLE_SUBSCRIPTION_WARNING_CODE_PAST_DUE_OR_CANCELLED_RETRY = 100002
